import { Box, Flex, Row, Text } from '@atom-web/micros'
import { useContext, useEffect } from 'react'

import getLangagesApi from '../features/auth/actions/getLangagesApi'
import LanguagePillBengali from '../icons/LanguagePillBengali'
import LanguagePillEnglish from '../icons/LanguagePillEnglish'
import LanguagePillHindi from '../icons/LanguagePillHindi'
import LanguagePillKanada from '../icons/LanguagePillKanada'
import LanguagePillMalayalam from '../icons/LanguagePillMalayalam'
import LanguagePillMarathi from '../icons/LanguagePillMarathi'
import LanguagePillOdia from '../icons/LanguagePillOdia'
import LanguagePillPunjabi from '../icons/LanguagePillPunjabi'
import LanguagePillTamil from '../icons/LanguagePillTamil'
import LanguagePillTelungu from '../icons/LanguagePillTelungu'
import AppContext from '../store/AppContext'
import { SET_ALL_LANGUAGES } from '../store/Constants'

const getLanguagePill = language => {
	switch (language.toLowerCase()) {
		case 'english':
			return <LanguagePillEnglish />
		case 'bengali':
			return <LanguagePillBengali />
		case 'hindi':
			return <LanguagePillHindi />
		case 'telungu':
			return <LanguagePillTelungu />
		case 'malayalam':
			return <LanguagePillMalayalam />
		case 'marathi':
			return <LanguagePillMarathi />
		case 'odia':
			return <LanguagePillOdia />
		case 'punjabi':
			return <LanguagePillPunjabi />
		case 'tamil':
			return <LanguagePillTamil />
		default:
			return <LanguagePillKanada />
	}
}

const LanguageSelection = ({ onChange }) => {
	const [{ allLanguages }, appDispatch] = useContext(AppContext)

	useEffect(() => {
		if (!allLanguages) {
			getLangagesApi().then(res => {
				if (res.data) {
					appDispatch({
						type: SET_ALL_LANGUAGES,
						payload: { allLanguages: res?.data },
					})
				}
			})
		}
	}, [])

	return (
		<Row css={{ width: '100%', gap: '20px' }} wrap={'wrap'} justify={'center'}>
			{allLanguages?.map((item, inx) => {
				return (
					<Flex
						key={`lang-${inx}`}
						align={'center'}
						justify={'center'}
						css={{
							width: '154px',
							height: '48px',
							padding: '12px 16px',
							backgroundColor: '#F3F4FB',
							borderRadius: '8px',
							border: '1px solid #E8EAF8',
							cursor: 'pointer',
							position: 'relative',
							overflow: 'hidden',
							'&:hover': {
								border: '1px solid #85E0AC',
								'& svg rect': {
									fill: '#E4FBEF',
								},
								'& svg path': {
									fill: '#CBF1DD',
								},
							},
						}}
						onClick={() => onChange(item)}
					>
						<Box
							css={{
								position: 'absolute',
								width: '100%',
								height: '100%',
							}}
						>
							{getLanguagePill(item.key)}
						</Box>
						<Flex
							css={{
								position: 'absolute',
							}}
							align={'center'}
							justify={'center'}
						>
							<Text
								css={{
									fontSize: '17px',
									fontWeight: '$bold',
									textTransform: 'capitalize',
								}}
							>
								{item.key}
							</Text>
						</Flex>
					</Flex>
				)
			})}
		</Row>
	)
}

export default LanguageSelection
